export default __webpack_public_path__ + "static/media/pause-circle.f9af4a68.svg";